import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './Header.css';

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const { user, creditBalance, logout } = useAuth();
  const location = useLocation();
  const isResults = location.pathname === '/results';
  const isProfile = location.pathname === '/profile';

  const closeMenu = () => setMenuOpen(false);

  return (
    <>
    <header className="site-header">
      <div className="site-header-inner">

        {/* ── Brand ──────────────────────────────────────────────── */}
        <Link to="/" className="site-header-brand" onClick={closeMenu}>
          <img src="/Logo-01.png" alt="Ride-Link" className="site-header-logo" />
        </Link>

        {/* ── Nav links ──────────────────────────────────────────── */}
        <nav className={`site-header-nav${menuOpen ? ' open' : ''}`} role="navigation">
          <a href="/#how-it-works" onClick={closeMenu}>How it Works</a>
          <a href="/#features"    onClick={closeMenu}>Contact</a>
          <Link to="/carriers"   onClick={closeMenu}>Carriers</Link>
          <Link to="/faq"        onClick={closeMenu}>FAQ</Link>
          <Link to="/developers" onClick={closeMenu}>API</Link>
        </nav>

        {/* ── Right actions ──────────────────────────────────────── */}
        <div className="site-header-actions">
          {user && (
            <div className="site-header-user">
              <Link to="/profile" className="site-header-credits" title="View profile">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
                  <rect x="3" y="11" width="18" height="11" rx="2" stroke="currentColor" strokeWidth="2"/>
                  <path d="M7 11V7a5 5 0 0 1 10 0v4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                </svg>
                {creditBalance} credits
              </Link>
              <Link to="/profile" className="site-header-avatar-link" onClick={closeMenu}>
                {user.picture ? (
                  <img src={user.picture} alt={user.name} className="site-header-avatar" referrerPolicy="no-referrer" />
                ) : (
                  <div className="site-header-avatar-initials">
                    {user.name?.charAt(0).toUpperCase() || 'U'}
                  </div>
                )}
              </Link>
              <span className="site-header-username">{user.name?.split(' ')[0]}</span>
              <button className="site-header-signout" onClick={logout}>Sign out</button>
            </div>
          )}

          {isResults || isProfile ? (
            <Link to="/" className="site-header-btn-outline">← Home</Link>
          ) : (
            <Link to="/results" className="site-header-btn-primary">Track Package</Link>
          )}
        </div>

        {/* ── Hamburger (mobile) ─────────────────────────────────── */}
        <button
          className={`site-header-hamburger${menuOpen ? ' open' : ''}`}
          onClick={() => setMenuOpen(v => !v)}
          aria-label="Toggle navigation"
          aria-expanded={menuOpen}
        >
          <span />
          <span />
          <span />
        </button>
      </div>

    </header>
    {/* Mobile drawer backdrop — outside <header> so z-index is root-level */}
    {menuOpen && <div className="site-header-backdrop" onClick={closeMenu} />}
    </>
  );
}
